import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconDoors = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M19.97 4H10.38C9.9 4 9.43 4.17 9.06 4.49L2.71 9.93C2.26 10.32 2 10.88 2 11.47V20H19.97C21.09 20 22 19.09 22 17.97V6.03C22 4.91 21.09 4 19.97 4ZM10.38 6L20 6.03V10H5.71L10.39 6H10.38ZM19.97 18H4V12H20V17.97C20 17.97 19.99 18 19.97 18Z" }),
            React.createElement("path", { d: "M19 13H16V15H19V13Z" }))));
};
